import React from 'react'

export const ProgressLabel = ({ ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} />
)

ProgressLabel.displayName = 'ProgressLabel'
